// extracted by mini-css-extract-plugin
export default {"popup__title":"mediaDevicesErrorPopup_popup__title__Fb86-","popup__img":"mediaDevicesErrorPopup_popup__img__DKu2L","popup__text":"mediaDevicesErrorPopup_popup__text__z6IMb"};